(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ft-size-recommender"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ft-size-recommender')) {
  class FtSizeRecommender extends HTMLElement {
    static normalize(value) {
      return String(value || '').trim().toUpperCase().replace(/\s+/g, '').replace(/^XXXL$/, '3XL').replace(/^XXL$/, '2XL');
    }

    static hydrate(config) {
      const available = new Map((config.optionValues || []).map(option => [this.normalize(option.name), option]));
      const seen = new Set();
      let duplicate = false;
      const rows = (config.rows || []).filter(row => {
        const key = this.normalize(row.size);
        if (seen.has(key)) { duplicate = true; return false; }
        if (!key || !available.has(key)) return false;
        seen.add(key);
        return true;
      }).map(row => ({ ...row, size: available.get(this.normalize(row.size)).name, optionId: available.get(this.normalize(row.size)).id }));
      if (duplicate) return { rows: [], measurements: [], regions: [] };
      const required = { 'Ganzkörper': ['bust', 'waist', 'hips'], 'Oberteil': ['bust', 'waist'], 'Unterteil': ['waist', 'hips'], 'Nur Größenumrechnung': [] }[config.basis || 'Ganzkörper'] || [];
      const validMeasurements = required.filter(key => rows.length > 1 && rows.every((row, index) => {
        const range = row[key];
        return Array.isArray(range) && range.length === 2 && range.every(value => typeof value === 'number' && Number.isFinite(value) && value > 0 && value <= 300) && range[0] <= range[1] && (index === 0 || range[0] > rows[index - 1][key][0] && range[1] > rows[index - 1][key][1]);
      }));
      const measurements = (config.verified === true || config.demo === true) && validMeasurements.length === required.length ? validMeasurements : [];
      const regions = ['eu', 'uk', 'us'].filter(key => rows.length && rows.every(row => typeof row[key] === 'string' && row[key].trim()));
      return { rows, measurements, regions };
    }

    static recommend(rows, measurements, values) {
      if (!measurements.length || measurements.some(key => values[key] === null || values[key] === undefined || values[key] === '' || !Number.isFinite(Number(values[key])))) return { status: 'incomplete' };
      const per = {};
      let index = -1;
      let by = null;
      let between = false;
      for (const key of measurements) {
        const value = Number(values[key]);
        if (value < rows[0][key][0] || value > rows[rows.length - 1][key][1]) return { status: 'outside', by: key };
        const hit = rows.findIndex(row => value <= row[key][1]);
        const gap = value < rows[hit][key][0];
        per[key] = hit;
        between = between || gap;
        if (hit > index) { index = hit; by = key; }
      }
      return { status: 'ok', index, by, between, per, differs: new Set(Object.values(per)).size > 1 };
    }

    connectedCallback() {
      if (this.ready) return;
      try {
        this.config = JSON.parse(this.dataset.config);
        this.model = FtSizeRecommender.hydrate(this.config);
        if (!this.model.rows.length || !this.config.text || !this.config.optionPosition) return;
        if (!this.model.measurements.length && this.config.showUsual === false) return;
        this.text = this.config.text;
        this.unit = 'cm';
        this.region = this.model.regions[0] || '';
        this.mode = this.model.measurements.length ? 'measure' : 'usual';
        this.values = this.config.demo === true ? Object.fromEntries(this.model.measurements.map(key => [key, Math.round((this.model.rows[0][key][0] + this.model.rows[0][key][1]) / 2)])) : {};
        this.usual = null;
        this.infoTab = 'chart';
        this.dialog = this.querySelector('dialog');
        this.dialog.addEventListener('click', event => this.handleClick(event));
        this.dialog.addEventListener('input', event => this.handleInput(event));
        this.dialog.addEventListener('pointerdown', event => {
          const range = event.target.closest('input[data-kind="range"]');
          if (range) range.closest('.ft-sr__slider')?.classList.add('is-adjusting');
        });
        ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(type => this.dialog.addEventListener(type, () => this.endSliderInteraction()));
        this.dialog.addEventListener('close', () => { this.endSliderInteraction(); this.restoreScroll(); });
        this.renderControls();
        this.renderResult();
        this.renderInformation();
        this.ready = true;
      } catch (error) {
        this.ready = false;
      }
    }

    disconnectedCallback() {
      this.endSliderInteraction();
      this.restoreScroll();
    }

    endSliderInteraction() {
      this.querySelectorAll('.ft-sr__slider.is-adjusting').forEach(slider => slider.classList.remove('is-adjusting'));
    }

    updateSlider(range) {
      if (!range) return;
      const span = Number(range.max) - Number(range.min);
      const fill = span > 0 ? Math.max(0, Math.min(100, (Number(range.value) - Number(range.min)) / span * 100)) : 0;
      range.style.setProperty('--ft-sr-fill', `${fill}%`);
      const slider = range.closest('.ft-sr__slider');
      if (slider) {
        slider.style.setProperty('--ft-sr-fill', `${fill}%`);
        const value = slider.querySelector('[data-sr-value]');
        if (value) value.textContent = `${Math.round(Number(range.value))} ${this.unit}`;
      }
    }

    escape(value) {
      return String(value == null ? '' : value).replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[character]);
    }

    translated(key, values = {}) {
      let value = this.text[key] || '';
      Object.entries(values).forEach(([token, replacement]) => { value = value.replaceAll(`[${token}]`, String(replacement)); });
      return this.escape(value);
    }

    format(value) {
      return Math.round(this.unit === 'in' ? value / 2.54 : value);
    }

    getSelector() {
      const section = this.closest('.section-main-product') || this.closest('.shopify-section');
      return section?.querySelector(`variant-picker .option-selector[data-index="${this.config.optionPosition}"]`);
    }

    getOption(row) {
      const selector = this.getSelector();
      if (!selector) return null;
      const options = [...selector.querySelectorAll('.js-option')];
      return options.find(option => String(option.dataset.valueId || option.dataset.value) === String(row.optionId)) || options.find(option => FtSizeRecommender.normalize(option.value || option.querySelector('.js-value')?.textContent || option.textContent) === FtSizeRecommender.normalize(row.size));
    }

    isUnavailable(option) {
      return !option || option.disabled || option.getAttribute('aria-disabled') === 'true' || option.classList.contains('is-unavailable');
    }

    open(opener) {
      if (!this.ready || typeof this.dialog.showModal !== 'function') return false;
      this.opener = opener;
      try {
        this.dialog.showModal();
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.scrollLocked = true;
        this.renderResult();
        return true;
      } catch (error) { return false; }
    }

    close() {
      if (this.dialog?.open) this.dialog.close();
      this.restoreScroll();
      this.opener?.focus();
    }

    restoreScroll() {
      if (!this.scrollLocked) return;
      document.documentElement.style.overflow = this.previousOverflow || '';
      this.scrollLocked = false;
    }

    renderControls() {
      const { rows, measurements, regions } = this.model;
      const pills = regions.map(region => `<button type="button" class="ft-sr__pill" data-sr-action="region" data-region="${region}" aria-pressed="${region === this.region}">${region.toUpperCase()}</button>`).join('');
      const units = measurements.length ? ['cm', 'in'].map(unit => `<button type="button" class="ft-sr__pill" data-sr-action="unit" data-unit="${unit}" aria-pressed="${this.unit === unit}">${unit}</button>`).join('') : '';
      const modes = measurements.length && this.config.showUsual !== false ? `<div class="ft-sr__tabs" role="tablist" aria-label="${this.translated('title')}"><button type="button" class="ft-sr__tab" role="tab" data-sr-action="mode" data-mode="measure" aria-selected="${this.mode === 'measure'}">${this.translated('measureTab')}</button><button type="button" class="ft-sr__tab" role="tab" data-sr-action="mode" data-mode="usual" aria-selected="${this.mode === 'usual'}">${this.translated('usualTab')}</button></div>` : '';
      const controls = this.mode === 'measure' ? measurements.map(key => {
        const min = Math.max(1, rows[0][key][0] - 5);
        const max = Math.min(300, rows[rows.length - 1][key][1] + 5);
        const value = this.values[key];
        const number = value == null ? '' : this.format(value);
        const slider = value == null ? (min + max) / 2 : value;
        const fill = Math.max(0, Math.min(100, (slider - min) / (max - min) * 100));
        return `<div class="ft-sr__measure"><label for="${this.id}-${key}">${this.translated(key)}<span class="ft-sr__hint">${this.translated(`${key}Hint`)}</span></label><div class="ft-sr__slider" style="--ft-sr-fill:${fill}%"><span class="ft-sr__value" data-sr-value aria-hidden="true">${this.format(slider)} ${this.unit}</span><input type="range" data-measurement="${key}" data-kind="range" style="--ft-sr-fill:${fill}%" aria-label="${this.translated(key)} (${this.unit})" min="${this.format(min)}" max="${this.format(max)}" step="1" value="${this.format(slider)}"></div><div class="ft-sr__number"><input type="number" id="${this.id}-${key}" data-measurement="${key}" data-kind="number" min="0" max="${this.format(300)}" step="1" inputmode="numeric" value="${number}" aria-label="${this.translated(key)} (${this.unit})"><span>${this.unit}</span></div></div>`;
      }).join('') : `<div class="ft-sr__usual-list">${rows.map((row, index) => `<button type="button" class="ft-sr__usual" data-sr-action="usual" data-index="${index}" aria-pressed="${this.usual === index}">${this.region ? `${this.region.toUpperCase()} ` : ''}${this.escape(this.region ? row[this.region] : row.size)}</button>`).join('')}</div>`;
      this.querySelector('[data-sr-controls]').innerHTML = `<div class="ft-sr__switches"><div class="ft-sr__pills">${pills}</div><div class="ft-sr__pills">${units}</div></div>${modes}${controls}`;
    }

    getResult() {
      if (this.mode === 'usual') return this.usual === null ? { status: 'usual-incomplete' } : { status: 'ok', index: this.usual, fromUsual: true };
      return FtSizeRecommender.recommend(this.model.rows, this.model.measurements, this.values);
    }

    renderResult() {
      const result = this.getResult();
      const box = this.querySelector('[data-sr-result]');
      this.result = result;
      let heading;
      let hint;
      let badge = '?';
      let detail = '';
      if (result.status === 'incomplete') { heading = this.translated('enter'); hint = this.translated('enterHint'); }
      else if (result.status === 'usual-incomplete') { heading = this.translated('chooseUsual'); hint = this.translated('chooseUsualHint'); }
      else if (result.status === 'outside') { heading = this.translated('outside'); hint = this.translated('outsideHint'); }
      else {
        const row = this.model.rows[result.index];
        badge = this.escape(row.size);
        heading = this.translated('result', { size: row.size });
        hint = result.fromUsual ? this.translated(this.model.measurements.length ? 'usualResult' : 'usualOnlyResult') : result.between ? this.translated('between') : result.differs ? this.translated('largest', { measurement: this.text[result.by] }) : this.translated('fits');
        if (!result.fromUsual) {
          detail = this.model.measurements.map(key => {
            const index = result.per[key];
            const range = this.model.rows[index][key];
            const within = range[1] === range[0] ? .5 : Math.max(.08, Math.min(.92, (this.values[key] - range[0]) / (range[1] - range[0])));
            const point = (index + within) / this.model.rows.length * 100;
            return `<div class="ft-sr__breakdown"><span>${this.translated(key)}</span><div class="ft-sr__track" style="--ft-sr-count:${this.model.rows.length};--ft-sr-point:${point}%">${this.model.rows.map((size, rowIndex) => `<span class="ft-sr__segment${rowIndex === index ? ' is-match' : ''}">${this.escape(size.size)}</span>`).join('')}<span class="ft-sr__dot" aria-hidden="true"></span></div></div>`;
          }).join('');
        }
        const unavailable = this.isUnavailable(this.getOption(row));
        detail += `<button type="button" class="ft-sr__select" data-sr-action="select"${unavailable ? ' disabled' : ''}>${unavailable ? this.translated('unavailable') : this.translated('select', { size: row.size })}</button>`;
      }
      box.innerHTML = `<div class="ft-sr__result-top"><div class="ft-sr__badge" aria-hidden="true">${badge}</div><div><h3>${heading}</h3><p>${hint}</p></div></div>${detail}`;
      const table = this.querySelector('[data-sr-information] table');
      if (table) [...table.querySelectorAll('tbody tr')].forEach((row, index) => row.classList.toggle('is-recommended', result.status === 'ok' && result.index === index));
    }

    renderInformation() {
      const { rows, measurements } = this.model;
      const keys = ['bust', 'waist', 'hips'];
      const showInstructions = this.config.showInstructions !== false;
      const tabs = this.config.showInstructions !== false ? `<div class="ft-sr__tabs" role="tablist" aria-label="${this.translated('chart')}"><button type="button" class="ft-sr__tab" role="tab" data-sr-action="info" data-tab="chart" aria-selected="${this.infoTab === 'chart'}">${this.translated('chart')}</button><button type="button" class="ft-sr__tab" role="tab" data-sr-action="info" data-tab="how" aria-selected="${this.infoTab === 'how'}">${this.translated('how')}</button></div>` : '';
      const howContent = `<div class="ft-sr__how"><figure class="ft-sr__model"><img src="${this.escape(this.config.howImage)}" width="480" height="720" loading="eager" fetchpriority="high" decoding="async" alt="${this.translated('howImageAlt')}"><svg class="ft-sr__markers" viewBox="0 0 1024 1536" aria-hidden="true"><g fill="none" stroke="#df7b42" stroke-width="8" stroke-dasharray="22 16" stroke-linecap="round"><path d="M410 387Q530 448 661 397"/><path d="M415 563Q529 600 648 568"/><path d="M371 733Q530 797 678 744"/></g><g fill="var(--ft-sr-accent)"><circle cx="340" cy="392" r="51"/><circle cx="339" cy="565" r="51"/><circle cx="310" cy="738" r="51"/></g><g text-anchor="middle" dominant-baseline="central"><text x="340" y="392">1</text><text x="339" y="565">2</text><text x="310" y="738">3</text></g></svg></figure><ol>${keys.map((key,index)=>`<li><span class="ft-sr__instruction-index" aria-hidden="true">${index+1}</span><div><strong>${this.translated(key)}</strong>${this.translated(`${key}Hint`)}</div></li>`).join('')}</ol></div><p class="ft-sr__fine">${this.translated('tapeNote')}</p>`;
      const columns = ['size', ...(this.region ? [this.region] : []), ...measurements];
      const chartContent = `<div class="ft-sr__table-scroll"><table><thead><tr>${columns.map(key => `<th scope="col">${key === 'size' ? this.translated('size') : key === this.region ? key.toUpperCase() : `${this.translated(key)} (${this.unit})`}</th>`).join('')}</tr></thead><tbody>${rows.map((row, index) => `<tr${this.result?.status === 'ok' && this.result.index === index ? ' class="is-recommended"' : ''}>${columns.map(key => `<${key === 'size' ? 'th scope="row"' : 'td'}>${key === 'size' ? this.escape(row.size) : key === this.region ? this.escape(row[key]) : `${this.format(row[key][0])}–${this.format(row[key][1])}`}</${key === 'size' ? 'th' : 'td'}>`).join('')}</tr>`).join('')}</tbody></table></div>${measurements.length ? `<p class="ft-sr__fine">${this.translated('bodyNote')}</p>` : ''}`;
      const information = this.querySelector('[data-sr-information]');
      if (!information.querySelector('[data-sr-panel="chart"]')) {
        information.innerHTML = tabs + '<div data-sr-panel="chart"></div>' + (showInstructions ? `<div data-sr-panel="how" hidden>${howContent}</div>` : '');
        const photo = information.querySelector('.ft-sr__model img');
        if (photo && typeof photo.decode === 'function') photo.decode().catch(() => {});
      }
      const showHow = showInstructions && this.infoTab === 'how';
      const chart = information.querySelector('[data-sr-panel="chart"]');
      chart.innerHTML = chartContent;
      chart.hidden = showHow;
      const how = information.querySelector('[data-sr-panel="how"]');
      if (how) how.hidden = !showHow;
      information.querySelectorAll('[data-sr-action="info"]').forEach(button => button.setAttribute('aria-selected', String(button.dataset.tab === (showHow ? 'how' : 'chart'))));
      const legacy = document.getElementById(this.config.legacyTarget);
      this.querySelector('[data-sr-action="original"]').hidden = !legacy;
    }

    handleInput(event) {
      const input = event.target.closest('input[data-measurement]');
      if (!input) return;
      const key = input.dataset.measurement;
      const entered = input.value === '' ? null : Math.round(Number(input.value));
      if (entered !== null && Number.isFinite(entered)) input.value = String(entered);
      this.values[key] = entered === null || !Number.isFinite(entered) ? null : Number((entered * (this.unit === 'in' ? 2.54 : 1)).toFixed(4));
      const counterpart = this.querySelector(`input[data-measurement="${key}"][data-kind="${input.dataset.kind === 'range' ? 'number' : 'range'}"]`);
      if (counterpart && this.values[key] !== null) counterpart.value = this.format(this.values[key]);
      const range = input.dataset.kind === 'range' ? input : counterpart;
      this.updateSlider(range);
      this.renderResult();
    }

    handleClick(event) {
      if (event.target === this.dialog) {
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
        return;
      }
      const button = event.target.closest('button[data-sr-action]');
      if (!button) return;
      const action = button.dataset.srAction;
      if (action === 'close') this.close();
      if (action === 'mode') { this.mode = button.dataset.mode; this.renderControls(); this.renderResult(); }
      if (action === 'region') { this.region = button.dataset.region; this.renderControls(); this.renderInformation(); }
      if (action === 'unit') { this.unit = button.dataset.unit; this.renderControls(); this.renderInformation(); }
      if (action === 'usual') { this.usual = Number(button.dataset.index); this.renderControls(); this.renderResult(); }
      if (action === 'info') { this.infoTab = button.dataset.tab; this.renderInformation(); }
      if (action === 'original') {
        const legacy = document.getElementById(this.config.legacyTarget);
        this.close();
        if (typeof legacy?.open === 'function') legacy.open(this.opener);
        else if (legacy && typeof theme !== 'undefined') theme.scrollToRevealElement(legacy);
      }
      if (action === 'select' && this.result?.status === 'ok') {
        const row = this.model.rows[this.result.index];
        const option = this.getOption(row);
        if (this.isUnavailable(option)) { this.renderResult(); return; }
        const select = option.closest('custom-select');
        if (select && typeof select.selectOption === 'function') select.selectOption(option);
        else if (option.matches('input[type="radio"]')) option.click();
        else { this.querySelector('[data-sr-result] h3').textContent = this.text.selectError; return; }
        this.close();
      }
    }
  }
  customElements.define('ft-size-recommender', FtSizeRecommender);
  document.addEventListener('click', event => {
    const trigger = event.target.closest?.('button[data-ft-sr-open]');
    if (!trigger) return;
    const controller = document.getElementById(trigger.dataset.ftSrOpen);
    if (controller?.ready && controller.open(trigger)) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-block"] && !Shopify.designMode) return;
  try {
    const updateCarouselColorName = (event) => {
    if (!(event.target instanceof Element)) return;
    const swatch = event.target.closest('.product-block-options__item[data-option-item]');
    const imageButton = event.type === 'click' && event.target.closest('.image-page-button');
    if (!swatch && !imageButton) return;
    const card = event.target.closest('product-block');
    const label = card?.querySelector('[data-card-color-name]');
    if (!label) return;
    const rows = Array.from(card.querySelectorAll('.product-block-options[data-option-name]'));
    const colorRow = rows.find((row) => row.dataset.optionName === label.dataset.colorOption);
    if (!colorRow) return;
    if (swatch && swatch.closest('.product-block-options') === colorRow) {
      label.textContent = swatch.dataset.optionItem;
    } else if (imageButton) {
      const activeImage = card.querySelector('.product-block__image--active[data-media-id]');
      const match = Array.from(colorRow.querySelectorAll('[data-option-item][data-media]'))
        .find((item) => item.dataset.media === activeImage?.dataset.mediaId);
      if (match) label.textContent = match.dataset.optionItem;
    }
  };

  document.addEventListener('mouseover', updateCarouselColorName);
  document.addEventListener('focusin', updateCarouselColorName);
  document.addEventListener('click', updateCarouselColorName);
  } catch(e) { console.error(e); }
})();

})();
